import { NotificationEventId } from "./notifications.types";

export interface NotificationFormat {
  theme: string;
  text: string;
}

export const NOTIFICATION_DISPLAY: {
  [key in NotificationEventId]: NotificationFormat;
} = {
  ClientAddedCorrections: {
    theme: "red",
    text: "Correction",
  },
  ClientAddedReferences: {
    theme: "red",
    text: "Reference",
  },
  ClientApprovedVendorEditTask: {
    theme: "red",
    text: "Vendor edit",
  },
  ClientApprovedResumedShots: {
    theme: "red",
    text: "Resume task",
  },
  ClientApprovedVendorAddCorrections: {
    theme: "red",
    text: "Correction",
  },
  ClientApprovedVendorAddReferences: {
    theme: "red",
    text: "Reference",
  },
  ClientApprovedVendorDeliveryDates: {
    theme: "red",
    text: "Deadline",
  },
  ClientApprovedVendorEditSourceMedia: {
    theme: "red",
    text: "Correction",
  },
  ClientApprovedVendorEditSpecs: {
    theme: "red",
    text: "Correction",
  },
  ClientAwardedTaskShotBids: {
    theme: "blue",
    text: "New bid",
  },
  ClientCancelledPendingStateChanges: {
    theme: "red",
    text: "Cancelled",
  },
  ClientCancelledShots: {
    theme: "red",
    text: "Cancelled",
  },
  ClientCommentedOnInvoice: {
    theme: "yellow",
    text: "Message",
  },
  ClientCommentedOnTaskShotBid: {
    theme: "yellow",
    text: "Message",
  },
  ClientCommentedOnVendorBidRequest: {
    theme: "yellow",
    text: "Message",
  },
  ClientEditedSourceMedia: {
    theme: "red",
    text: "New source",
  },
  ClientEditedSpecs: {
    theme: "red",
    text: "Correction",
  },
  ClientEditedTaskShotBidsDeliveryDates: {
    theme: "red",
    text: "Deadline",
  },
  ClientMessagedVendor: {
    theme: "yellow",
    text: "Message",
  },
  ClientRejectedVendorEditTask: {
    theme: "red",
    text: "Vendor edit",
  },
  ClientResumedShots: {
    theme: "red",
    text: "Resume",
  },
  ClientEditedBidRequestService: {
    theme: "green",
    text: "Service Update",
  },
  ClientPaidInvoice: {
    theme: "green",
    text: "Invoice",
  },
  UserMessagedVendor: {
    theme: "green",
    text: "Invoice",
  },
  NewVendorBidRequest: {
    theme: "blue",
    text: "New bid",
  },
  VendorAcceptedBidRequest: {
    theme: "blue",
    text: "New bid",
  },
  VendorAddedCorrections: {
    theme: "red",
    text: "Correction",
  },
  VendorAddedReferences: {
    theme: "red",
    text: "References",
  },
  RejectVendorBidRequest: {
    theme: "red",
    text: "Bid Turned Down",
  },
  VendorCancelledPendingStateChanges: {
    theme: "red",
    text: "Cancelled",
  },
  VendorCommentedOnTaskShotBid: {
    theme: "yellow",
    text: "Message",
  },
  VendorCommentedOnVendorBidRequest: {
    theme: "yellow",
    text: "Message",
  },
  VendorCommentedOnInvoice: {
    theme: "yellow",
    text: "Message",
  },
  VendorEditedInvoice: {
    theme: "green",
    text: "Invoice edit",
  },
  VendorDelivery: {
    theme: "green",
    text: "Delivery",
  },
  VendorEditedSourceMedia: {
    theme: "red",
    text: "New source",
  },
  VendorEditedSpecs: {
    theme: "red",
    text: "Specs",
  },
  VendorEditedTaskShotBidsDeliveryDates: {
    theme: "red",
    text: "Deadline",
  },
  VendorEditedPendingTaskShotBids: {
    theme: "blue",
    text: "New bid",
  },
  VendorInvoicedClient: {
    theme: "green",
    text: "Invoice",
  },
  VendorResumedShots: {
    theme: "red",
    text: "Resume",
  },
  VendorEditedPendingStateChange: {
    theme: "red",
    text: "Correction",
  },
  VendorEditedTask: {
    theme: "red",
    text: "Vendor edit",
  },
  VendorEditedTaskWithoutStateChange: {
    theme: "blue",
    text: "Vendor edit",
  },
  VendorMessagedClient: {
    theme: "yellow",
    text: "Message",
  },
  VendorMessagedUser: {
    theme: "yellow",
    text: "Message",
  },
  // These are for Hotspring staff, will not be shown in the UI for vendor/client.
  VideoProcessingErrored: {
    theme: "red",
    text: "Error",
  },
  VideoProcessingSucceeded: {
    theme: "green",
    text: "Success",
  },
  NewUserInvited: {
    theme: "green",
    text: "Success",
  },
  NewUserSignedUp: {
    theme: "green",
    text: "Success",
  },
  WelcomeNewUser: {
    theme: "green",
    text: "Success",
  },
  UserCommentedOnUserTaskShot: {
    theme: "yellow",
    text: "Message",
  },
};
